import Vue from 'vue'
import iView from 'iview'
import Util from '../libs/util'
import VueRouter from 'vue-router'
import store from '../store'
import { routers } from './router'

Vue.use(VueRouter);

// 路由配置
const RouterConfig = {
  //mode: 'history',
  routes: routers
};

export const router = new VueRouter(RouterConfig);

router.beforeEach((to, from, next) => {
  iView.LoadingBar.start();
  Util.title(to.meta.title);
  let token = Vue.ls.get("token")
  if (!token && to.meta.noAuth !== true) {
    next('/login')
  } else {
    if (!store.state.user.user.id && to.meta.noAuth !== true) {
      store.dispatch('getUserInfo').then((ret) => {
        console.log('获取用户信息成功')
        next()
      }).catch(ret => {
      })
    } else {
      next()
    }
  }
});

router.afterEach((to) => {
  iView.LoadingBar.finish();
  window.scrollTo(0, 0);
});


// WEBPACK FOOTER //
// ./src/router/index.js